export const STATUS_FOR_VERIFY = [{ label: "Verified", value: "Verified" }];

export const VERIFY_ORDER_STATUS = {
  STATUS: "status",
};

export const CREATE_EMS_SCENE = {
  PATIENT_NAME: "patientName",
  PATIENT_BSA_ID: "patientBSAId",
  CAMP_NAME: "campName",
  JUN: "jun",
  CHIEF_COMPLAINT: "chiefComplaint",
  INJURY_TYPE: "injuryType",
  INJURY_LOCATION: "injuryLocation",
  CAUSE_OF_INJURY_NAME: "causeOfInjury",
  WITNESS_NAME: "witnessName",
  INCIDENT_LOCATION: "incidentLocation",
  INCIDENT_DATE: "incidentDate",
  INCIDENT_TIME: "incidentTime",
  TYPE_OF_CARE: "typeOFCare",
  FACILITY: "facility",
  TYPE_OF_CARE_NAME: "typeOfCareName",
};
